import { render, staticRenderFns } from "./AdminMessage.vue?vue&type=template&id=99b75f5e&"
import script from "./AdminMessage.vue?vue&type=script&lang=js&"
export * from "./AdminMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports